import { ASCII } from "../components/ASCII";
import { Search } from "../components/Search";
import "../styles/ass.css";
import React, { ChangeEvent, ProviderProps, ReactNode, useContext, useRef, useState } from "react";
import webmaster from 'url:../assets/ascii/webmaster.txt';
import CursorProvider, { CursorState } from "./CursorProvider";
import { GetCrsInfo } from "../components/MagicCursor";
import { useLocation, useNavigate } from "react-router";
import PlayerProvider, { PlayerContext } from "./PlayerProvider";
import { ALL_SITE_INFOS, GetSiteInfo, SITE_INFO_TROK } from "./SitesProvider";

export type AssistantContext = {
    x: number;
    y: number;
};

const context = React.createContext<AssistantContext>({
    x: 16,
    y: 16
});

const ToolbarProvider = (props: { children: ReactNode }) => {
    const nav = useNavigate();
    const loc = useLocation();

    const value : AssistantContext = { 
        x: 16,
        y: 16
    };

    const toolbar = <div className="h-box gap-8 center-all">
        <div className="z-top all-ass ass-left" />
        <div className="z-top all-ass ass-right" />
        <div className="z-top all-ass ass-bottom h-box center-all">
            <div style={{width: 216}} />
            <button className="og-button" onClick={() => { nav('/') }}>Exit</button>
            <div className="flex-spacing" />
            <CrsSelector />
            <div className="width-32" />
            <QuickNav />
            <div className="width-32" />
            <Search />
            <div className="width-32" />
            <div className="flex-spacing" />
        </div>
        <div className="z-top all-ass ass-top h-box center-all">
            <DebugBar />
        </div>
        <div className="z-top ass-screen crt no-events" />
        <div className="z-top ass-middle no-events" />
        <div className="z-top asswm">
            <ASCII id='twm' ascii={webmaster} size={4} />
        </div>
    </div>

    return (
        <context.Provider value={value}>
            <div className="ass-padding">
                { props.children }
            </div>
            { loc.pathname == '/' ? null : toolbar }
        </context.Provider>
    );
};

function CrsSelector (props: {}) {
    return <div className="h-box center-all gap-4">
        { CrsBtn (CursorState.STD) }
        { CrsBtn (CursorState.HAM) }
        { CrsBtn (CursorState.YOY) }
        { CrsBtn (CursorState.PLZ) }
        { CrsBtn (CursorState.KY1) }
        { CrsBtn (CursorState.KY2) }
        { CrsBtn (CursorState.KY3) }
    </div>;
}

function CrsBtn (state : CursorState) {
    const playerProvider = useContext(PlayerProvider.context);
    const cursorProvider = useContext(CursorProvider.context);
    const info = GetCrsInfo(state);
    if (!playerProvider.hasUnlockedCursor(info.key))
        return null;
    return <button className="h-box center-all og-button" style={{ width: 36, height: 36 }} onClick={() => { cursorProvider.setState(state); }}><img className="width-24 height-24" src={info.icon} /></button>;
}

function QuickNav (props: {}) {
    const playerProvider = useContext(PlayerProvider.context);
    const loc = useLocation();
    const matchedSite = ALL_SITE_INFOS.find(s => loc.pathname.startsWith(s.path));
    const currentPath = matchedSite !== undefined ? matchedSite.path : SITE_INFO_TROK.path;
    const nav = useNavigate();
    const [site, setSite] = useState(currentPath);

    const handleSelect = (e : ChangeEvent<HTMLSelectElement>) => {
        setSite(e.target.value);
    };

    const handleSubmit = () => {
        nav(site);
    };

    const select = <select name="pages" id="pages" onChange={handleSelect} className="width-128" value={site}>
        { playerProvider.data.sites.map(s => NavOption(s)) }
    </select>;

    return <form onSubmit={handleSubmit} className="h-box gap-4 center-all">
        <b>Navigate</b>
        { select }
        <input type="submit" value="Go!" className="og-button" />
    </form>
}

function NavOption(key: string) {
    const siteInfo = GetSiteInfo(key);
    if (siteInfo === undefined)
        return null;
    return <option key={key} value={siteInfo.path}>{siteInfo.name}</option>
}

function DebugBar() {
    const player = useContext(PlayerProvider.context);
    const nav = useNavigate();
    return <div className="h-box align-end justify-end gap-4 width-100p">
        <button className="og-button" onClick={() => { player.debugUnlockAll(); }}>Unlock All</button>
        <button className="og-button" onClick={() => { 
            nav(SITE_INFO_TROK.path);
            player.debugClearAll(); 
        }}>Clear All</button>
    </div>   
}

ToolbarProvider.context = context;

export default ToolbarProvider;